var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayWithCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3097 6.01052C14.3097 4.18812 13.1369 2.96252 11.3929 2.96252H4.9953C3.2497 2.96252 2.0769 4.18812 2.0769 6.01052C2.0769 6.0768 2.13063 6.13053 2.1969 6.13053H14.1897C14.256 6.13053 14.3097 6.0768 14.3097 6.01052Z",
    fill: "#2C264B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5276 8.20566C17.13 7.53846 16.4724 7.08966 15.6252 6.90806C15.4923 6.87926 15.3668 6.9805 15.3668 7.11645V10.3857C15.3668 12.6513 13.838 14.2337 11.6476 14.2337H5.68821C5.50505 14.2337 5.39235 14.4295 5.50434 14.5745C5.90032 15.087 6.48149 15.4597 7.21399 15.6177L13.4684 16.9593C13.7108 17.0113 13.9476 17.0369 14.1764 17.0369C15.5516 17.0361 16.63 16.1193 16.958 14.5897L17.8364 10.4993C18.0188 9.64489 17.9124 8.85209 17.5276 8.20566Z",
    fill: "#2C264B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3097 10.1953V7.57124C14.3097 7.43869 14.2023 7.33124 14.0697 7.33124H2.3169C2.18436 7.33124 2.0769 7.43869 2.0769 7.57124V10.1953C2.0769 12.0177 3.2497 13.2433 4.9953 13.2433H11.3921C13.1369 13.2433 14.3097 12.0177 14.3097 10.1953Z",
    fill: "#2C264B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayWithCard);
export default __webpack_public_path__ + "static/media/pay-with-card.0a6627fed71003ed12838ed6e4c56366.svg";
export { ForwardRef as ReactComponent };